/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QarRejectsDarRequestDto
 */
export interface QarRejectsDarRequestDto {
    /**
     * Organization Id for whose benefit the workflow is performed or the user works
     * @type {string}
     * @memberof QarRejectsDarRequestDto
     */
    orgId?: string;
    /**
     * User Id
     * @type {string}
     * @memberof QarRejectsDarRequestDto
     */
    rejectedDarId: string;
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof QarRejectsDarRequestDto
     */
    workflowInstanceId: string;
}

/**
 * Check if a given object implements the QarRejectsDarRequestDto interface.
 */
export function instanceOfQarRejectsDarRequestDto(value: object): boolean {
    if (!('rejectedDarId' in value)) return false;
    if (!('workflowInstanceId' in value)) return false;
    return true;
}

export function QarRejectsDarRequestDtoFromJSON(json: any): QarRejectsDarRequestDto {
    return QarRejectsDarRequestDtoFromJSONTyped(json, false);
}

export function QarRejectsDarRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): QarRejectsDarRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'orgId': json['orgId'] == null ? undefined : json['orgId'],
        'rejectedDarId': json['rejectedDarId'],
        'workflowInstanceId': json['workflowInstanceId'],
    };
}

export function QarRejectsDarRequestDtoToJSON(value?: QarRejectsDarRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'orgId': value['orgId'],
        'rejectedDarId': value['rejectedDarId'],
        'workflowInstanceId': value['workflowInstanceId'],
    };
}

